import React from "react";
import "../assets/css/socios.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import fotoGeneral from "../assets/img/fotoGeneral.jpg";

const colaboradores = [
  {
    img: require("../assets/img/colaborador1.jpg"),
    nombre: "Bruno José Sagástegui Sánchez",
    cargo: "ASESOR LEGAL",
  },
  {
    img: require("../assets/img/colaborador10.jpg"),
    nombre: "Fiorella Lizbet Rojas Paredes",
    cargo: "ASESORA LEGAL",
  },
  {
    img: require("../assets/img/colaborador3.jpg"),
    nombre: "Brenda Abigail Barrios Vasquez",
    cargo: "ASESORA LEGAL",
  },
  {
    img: require("../assets/img/colaborador7.jpg"),
    nombre: "Edinson Gustavo Leiva Polo",
    cargo: "ASESOR LEGAL",
  },
  {
    img: require("../assets/img/colaborador2.jpg"),
    nombre: "Brisa Antonella Villanueva Villarreal",
    cargo: "ASESORA LEGAL",
  },
  {
    img: require("../assets/img/colaborador11.jpg"),
    nombre: "Angélica Alayo Garcia",
    cargo: "ASESORA CONTABLE",
  },
  // {
  //    img: require("../assets/img/colaborador13.jpg"),
  //    nombre: "Areliz Eliana Vigo Mendoza",
  //    cargo: "ASESORA CONTABLE",
  // },
  // {
  //   img: require("../assets/img/colaborador4.jpg"),
  //   nombre: "Renzo Renatto Guerrero Cabredo",
  //   cargo: "ASISTENTE LEGAL",
  // },
  {
    img: require("../assets/img/colaborador8.jpg"),
    nombre: "Lourdes de Fatima Ipanaque Chuñe",
    cargo: "ASISTENTE LEGAL",
  },
  {
    img: require("../assets/img/colaborador9.jpg"),
    nombre: "Greissy Martyori Chavez Perez",
    cargo: "ASISTENTE LEGAL",
  },
  {
    img: require("../assets/img/colaborador5.jpg"),
    nombre: "Jose Alonso Holguin Cruz",
    cargo: "ASISTENTE LEGAL",
  },
  // {
  //   img: require("../assets/img/colaborador12.jpg"),
  //   nombre: "Ana Lucia Saldaña",
  //   cargo: "ASISTENTE CONTABLE",
  // },
  // {
  //   img: require("../assets/img/colaborador6.jpg"),
  //   nombre: "Luis Alejandro Rubiños Sánchez ",
  //   cargo: "ASISTENTE LEGAL",
  // },
];
const socios = () => {
  return (
    <div className="contenedor-socios">
      <div className="fila-titulo">
        <h2>
          Juntos, en Torres & Torres, construimos soluciones legales con visión,
          <span>compromiso y trabajo en equipo.</span>
        </h2>
      </div>
      <div className="fila-socios">
        <div className="subFila-socios">
          <div className="texto-socios">
            <h3>Nuestros Socios</h3>
          </div>
          <div className="contenido-socios">
            <div className="foto-socios">
              <img
                src={fotoGeneral}
                alt="Foto de Juan de Dios Rafael Torres Durand"
              />
              <div className="nombre">
                <h3>JUAN DE DIOS RAFAEL TORRES DURAND</h3>
              </div>
            </div>
            <div className="parrafo-socios">
              <div className="descripcion-socio">
                <p>
                  Abogado egresado de la Universidad de Piura (Opus Dei), con
                  maestría en Derecho y especialización en Mediación,
                  Negociación y Conciliación. Socio Fundador y Gerente General
                  de Torres & Torres SA, además de Conciliador Extrajudicial
                  acreditado por el Ministerio de Justicia. Cuenta con amplia
                  experiencia académica como docente y director en universidades
                  reconocidas, incluyendo la Universidad Privada del Norte y la
                  Pontificia Universidad Católica del Perú (Filial Trujillo). Es
                  conferencista nacional e internacional y autor de artículos
                  jurídicos publicados en prestigiosas instituciones en Chile y
                  México. Actualmente se desempeña como Presidente del Instituto
                  de Solución de Controversias y Director del Centro de
                  Conciliación Soluciones Eficientes (Trujillo). Su trayectoria
                  refleja una sólida formación en derecho, negociación y
                  resolución alternativa de conflictos.
                </p>
              </div>
              <div className="nombre2">
                <h3>Temas de Especialización</h3>
                <p>
                  Derecho Civil y Procesal Civil, Derecho Contractual, Derecho
                  Corporativo, Derecho Constitucional, Derecho de la
                  Competencia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fila-colaboradores">
        <div className="texto-colaboradores">
          <h3>Nuestros Colaboradores</h3>
        </div>
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          slidesPerView={"auto"}
          loop={true}
          autoplay={{
            delay: 1503,
            disableOnInteraction: false,
          }}
          className="carrusel-colaboradores"
        >
          {colaboradores.map((colaborador, index) => (
            <SwiperSlide key={index} className="colaborador-slide">
              <div className="contenedor-nombre">
                <img src={colaborador.img} alt={colaborador.nombre} />
                <div className="nombre-colaborador">
                  <p>{colaborador.nombre}</p>
                  <h3>{colaborador.cargo}</h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
export default socios;
